// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';

// eslint-disable-next-line no-unused-vars
new Swiper( '.news-and-resources', {
	// configure Swiper to use modules.
	modules: [ Navigation ],
	// Default parameters.
	slidesPerView: 1.2,
	speed: 400,
	loop: true,
	spaceBetween: 24,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	// Responsive breakpoints.
	breakpoints: {
		// when window width is >= 768px.
		768: {
			slidesPerView: 2,
		},
		// when window width is >= 1280px.
		1280: {
			slidesPerView: 3,
		},
	},
} );
